(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/components/background.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/components/background.js');
"use strict";


const useTicketContext = svs.tickets.play.utils.context.useTicketContext;
const AnimatedBackgrounds = svs.tickets.play.components.AnimatedBackgrounds;
setGlobal('svs.tickets.play.components.Background', () => {
  const _useTicketContext = useTicketContext(),
    ticketInfo = _useTicketContext.ticketInfo;
  svs.tickets.play.utils.utils.useMainContentBg(ticketInfo);
  if (!ticketInfo) {
    return null;
  }
  return React.createElement(React.Fragment, null, React.createElement(AnimatedBackgrounds, {
    ticketInfo: ticketInfo
  }));
});

 })(window);